import { DSActions } from '../../../cimsPage/instances/ds'
import { CreateViewEditSoftRemoveRestore } from '../../common'

const actions = CreateViewEditSoftRemoveRestore({
  object: 'Action',
  page: DSActions,
  create: 'D7DB120B-7C5A-4273-9BF4-848D3EA0CE09',
  view: '0E9B429C-1867-4FFA-86CD-B77E676AAC84',
  edit: '2A853E60-855A-4331-9186-CB0443A415E3',
  removeRestore: 'CF219F4D-9690-4CD5-854F-2893FC1E8E37',
})

export const CreateDesignSubmittalAction = actions.Create
export const ViewDesignSubmittalAction = actions.View
export const EditDesignSubmittalAction = actions.Edit
export const RemoveRestoreDesignSubmittalAction = actions.RemoveRestore

export type DSActionPermission =
  | typeof CreateDesignSubmittalAction
  | typeof ViewDesignSubmittalAction
  | typeof EditDesignSubmittalAction
  | typeof RemoveRestoreDesignSubmittalAction
